// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:25:13

export default {
  "id": "qube-2048",
  "slug": "qube-2048",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/588cfae14b0748628b75e0fe3d86a1fb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/588cfae14b0748628b75e0fe3d86a1fb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Qube 2048",
      "description": "We present a unique arcade game that combines the dynamic gameplay of Q*bert and the mechanics of 2048!  You start with the number 2 and move across a grid of blocks, doubling its value. The goal is to reach the maximum number by planning your moves and avoiding obstacles.",
      "instructions": "The goal of the game is to reach the highest possible number by moving across a grid of blocks, doubling numbers, and avoiding obstacles, which requires strategic planning and precise moves.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2048",
        "3d",
        "color",
        "cube",
        "logic"
      ]
    },
    "zh-CN": {
      "title": "立方2048",
      "description": "我们推出一款独特的街机游戏，将Q*bert的动态玩法和2048的机制相结合！你从数字2开始，在一个方块网格中移动，将其值翻倍。目标是通过规划你的移动并避开障碍物来达到最大数字。",
      "instructions": "游戏目标是通过移动穿越方块网格，翻倍数字，并避开障碍物，以达到尽可能高的分数，这需要战略规划和精确的操作。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "2048",
        "3D",
        "色彩",
        "立方体",
        "逻辑"
      ]
    },
    "zh-TW": {
      "title": "立方2048",
      "description": "我們推出一款獨特的街機遊戲，結合了Q*bert的動態遊戲玩法與2048的機制！您從數字2開始，穿越一個方塊格，將其數值翻倍。目標是透過規劃步驟和避免障礙來達到最大數字。",
      "instructions": "遊戲的目標是透過在方塊格中移動、倍增數字和避免障礙物，達到最高的可能數字。這需要策略規劃和精準的操作。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "2048",
        "3D",
        "色彩",
        "立方體",
        "邏輯"
      ]
    },
    "zh-HK": {
      "title": "立方2048",
      "description": "我們介紹一款獨特的街機遊戲，結合了Q*bert的動態遊戲玩法和2048的機制！你從數字2開始，穿越一個方塊格，將其值加倍。目標是透過規劃你的移動和避開障礙來達到最大數字。",
      "instructions": "遊戲的目標是透過在方塊格中移動、倍增數字及避開障礙物，以達到最高的數字，這需要策略規劃和精準的步驟。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "2048",
        "3D",
        "色彩",
        "立方體",
        "邏輯"
      ]
    },
    "ja": {
      "title": "クーブー2048",
      "description": "ユニークなアーケードゲームを提供します。これは、Q*bertのダイナミックなゲームプレイと2048のメカニクスが融合したものです！スタート時は数字2からで、ブロックのグリッドを移動してその値を2倍にしていきます。目標は、自分の動きを計画し、障害物を避けながら最大の数字に達することです。",
      "instructions": "ゲームの目的は、ブロックのグリッドを移動して数値を2倍にし、障害物を避けながら最高の数値を目指すことです。これは戦略的な計画と正確な動きが必要です。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "2048",
        "3D",
        "色彩",
        "立方体",
        "論理"
      ]
    },
    "ko": {
      "title": "쿼브 2048",
      "description": "우리는 Q*bert의 활기찬 게임플레이와 2048의 기계적 원리를 결합한 독특한 아케이드 게임을 소개합니다! 시작은 숫자 2로, 블록의 그리드를 지나면서 그 값을 두배로 합니다. 목표는 이동 계획을 통해 최대 숫자에 도달하고 장애물을 피하는 것입니다.",
      "instructions": "게임의 목표는 블록의 그리드를 통해 이동하며 숫자를 두배로 하고 장애물을 피하여 가장 높은 숫자를 달성하는 것입니다. 이는 전략적인 계획과 정밀한 움직임이 필요합니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "2048",
        "3D",
        "색상",
        "컷",
        "로지크"
      ]
    },
    "fr": {
      "title": "Cube 2048",
      "description": "Nous présentons un jeu d'arcade unique qui combine le gameplay dynamique de Q*bert et les mécanismes de 2048 ! Vous commencez avec le nombre 2 et vous déplacez sur une grille de blocs, en doublant sa valeur. L'objectif est d'atteindre le nombre maximal en planifiant vos mouvements et en évitant les obstacles.",
      "instructions": "L'objectif du jeu est d'atteindre le plus grand nombre possible en se déplacant sur une grille de blocs, en doublant les nombres et en évitant les obstacles, ce qui nécessite une planification stratégique et des mouvements précis.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2048",
        "3D",
        "couleur",
        "cube",
        "logique"
      ]
    }
  }
};
